import API from './api';
import { pathWithId, resolvePath } from './endpointHelpers';

const VEHICLE_LIST_PATH = resolvePath(process.env.REACT_APP_VEHICLES_LIST, '/vehicles');
const VEHICLE_ID_TEMPLATE = resolvePath(
  process.env.REACT_APP_VEHICLES_BY_ID,
  `${VEHICLE_LIST_PATH || '/vehicles'}/:id`,
  '/vehicles/:id',
);

export const listVehicles = (params = {}) => {
  return API.get(VEHICLE_LIST_PATH || '/vehicles', { params });
};

export const getVehiclesByCabNumbers = (cabNumbers) => {
  const path = `${VEHICLE_LIST_PATH || '/vehicles'}/by-cabs`;
  return API.post(path, { cabNumbers });
};

export const getVehicle = (id) => {
  return API.get(
    pathWithId(id, process.env.REACT_APP_VEHICLES_BY_ID, VEHICLE_ID_TEMPLATE) ||
      `/vehicles/${id}`,
  );
};

export const getVehicleByCabNumber = async (cabNumber) => {
  const res = await API.get(VEHICLE_LIST_PATH || '/vehicles', { params: { cabNumber } });
  const list = res.data?.vehicles || res.data || [];
  const found = Array.isArray(list) ? list.find((v) => String(v.cabNumber) === String(cabNumber)) : null;
  return { vehicle: found };
};
